import {
    Component,
    HostListener,
    OnInit,
    ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { ApiService } from './core/services/api.service';
import { LanguageService } from './core/services/language.service';
import { UtilService } from './core/services/util.service';
import { Location } from '@angular/common';
import * as moment from 'moment';
import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';
import { HttpParams } from '@angular/common/http';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { MappingService } from './core/services/mapping.service';
import { TitleService } from './core/services/title.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    favIcon: HTMLLinkElement = document.querySelector('#appIcon');
    language: any = localStorage.getItem('language');
    profileData: any;
    currentRoute: any;
    setpassword: string;
    imagePathSrc: string;
    /**
     *  Constructor
     */
    constructor(
        private api: ApiService,
        private util: UtilService,
        private router: Router,
        private authFackservice: AuthService,
        private lan: LanguageService,
        public viewContainerRef: ViewContainerRef,
        private fuseSpashScreen: FuseSplashScreenService,
        private activeRoute: ActivatedRoute,
        private mapping: MappingService,
        private _location: Location,
        private titleService: TitleService
    ) {
        if (!environment.isLocal) {
            console.log = function () {};
        }
        console.warn = function () {};
        console.table = function () {};
        let checkLang;
        if (localStorage.getItem('language')) {
            checkLang = localStorage.getItem('language');
            if (checkLang == undefined) {
                localStorage.setItem('language', 'en');
                window.location.reload();
            }
            if (checkLang == null) {
                localStorage.setItem('language', 'en');
                window.location.reload();
            }
        }
        if (this.language) {
            moment.locale(this.language);
            this.lan.setLanguage(this.language);
        } else {
            this.language = 'en';
            moment.locale(this.language);
            this.lan.setLanguage(this.language);
        }

        if (localStorage.getItem('prevCred')) {
            let credential = JSON.parse(localStorage.getItem('prevCred'));
            let password = CryptoJS.AES.encrypt(
                credential.password,
                '0WlRFbfa3k'
            );
            let email = CryptoJS.AES.encrypt(credential.email, '0WlRFbfa3k');
            credential.password = password.toString();
            credential.email = email.toString();

            let CgVjURfZ: any = {};
            CgVjURfZ.pk1IRHm5 = email.toString();
            CgVjURfZ.g4z5ckyX = password.toString();
            localStorage.setItem('CgVjURfZ', JSON.stringify(CgVjURfZ));
            localStorage.removeItem('prevCred');
        }

        this.profileData = JSON.parse(localStorage.getItem('currentUser'));

        document.documentElement.style.setProperty(
            '--partnerReach-window-width',
            window.innerWidth.toString() + 'px'
        );

        this.api.refreshData.onmessage = (messageEvent) => {
            if (messageEvent.data == 'settings') {
                this.getSettingsData('new');
            } else if (messageEvent.data == 'logout') {
                this.router.navigate(['/sign-out']);
            } else if (messageEvent.data == 'login') {
                if (window['returnUrl']) {
                    this.router.navigateByUrl(window['retrunUrl']);
                    window.location.reload();
                } else {
                    this.router.navigateByUrl('/');
                    window.location.reload();
                }
            }
        };
        this.imagePathSrc = '/assets/images/logo/';
    }

    ngOnInit(): void {
        this.api.clientHeight = window.innerHeight;
        this.api.clientWidth = window.innerWidth;

        this.activeRoute.queryParams.subscribe((params) => {
            this.currentRoute = params['successMessage'];
            if (this.currentRoute) {
                this.util.showToast(this.currentRoute, true);
                // Remove the query parameter from the URL
                this.router.navigate([], {
                    relativeTo: this.activeRoute,
                    queryParams: { successMessage: null },
                    queryParamsHandling: 'merge',
                });
            }
        });

        const paramsMatch = window.location.href.match(/\?.+/);

        if (paramsMatch) {
            const params = new URLSearchParams(paramsMatch[0]);
            const authToken = params.get('token');
            const memberId = params.get('member_id');

            this.setpassword = params.get('is_setpassword');
            this.api.isSetPassword = this.setpassword;

            if (
                this.setpassword &&
                localStorage.getItem('token') &&
                localStorage.getItem('member_id')
            ) {
                this.api.getData('logout').subscribe({
                    next: (res: any) => {
                        if (res.success) {
                            localStorage.removeItem('token');
                            localStorage.removeItem('member_id');
                            localStorage.removeItem('currentUser');
                            localStorage.removeItem('active_module');
                            localStorage.removeItem('campaignName');
                            this.router.navigate(['/auth/set-password'], {
                                relativeTo: this.activeRoute,
                                queryParams: {
                                    team: params.get('team'),
                                    email: params.get('email'),
                                },
                            });
                        } else {
                        }
                    },
                    error: (err) => {
                        console.log('err', err);
                    },
                });
            }
            const errorMessage = params.get('errorMessage');
            const param = new HttpParams();
            if (errorMessage) this.util.showToast(errorMessage, true);
            if (authToken && memberId && !this.setpassword) {
                this.authFackservice.currentUserSetValue({
                    token: authToken,
                    member_id: memberId,
                });
                localStorage.setItem('token', authToken);
                localStorage.setItem('member_id', memberId);
                const user = {
                    token: authToken,
                    member_id: memberId,
                };
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.api.userToken = authToken;

                setTimeout(() => {
                    this._location.replaceState(
                        this._location.path().split('?')[0]
                    );
                }, 1000);
            }
        }

        if (localStorage.getItem('currentUser') && !this.setpassword) {
            this.getSettingsData();
            this.getCurrentPlan();
            this.getProfileData();
            this.mapping.getCustomField();
            this.getMappingField();
        } else {
            this.favIcon.href = this.imagePathSrc + 'favicon.svg';
        }

        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                if (localStorage.getItem('currentUser')) {
                    this.profileData = JSON.parse(
                        localStorage.getItem('currentUser')
                    );
                }
            }
        });
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        document.documentElement.style.setProperty(
            '--partnerReach-window-width',
            window.innerWidth.toString() + 'px'
        );

        this.api.clientHeight = window.innerHeight;
        this.api.clientWidth = window.innerWidth;
    }

    /**
     * * Get Settings Data
     */
    getSettingsData(type?) {
        this.api.getData('settings').subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.api.settingsData = res.data;

                    this.api.isLoadSettings.next(true);
                    let userData;
                    if (localStorage.getItem('currentUser')) {
                        userData = JSON.parse(
                            localStorage.getItem('currentUser')
                        );
                    }
                    if (res.language && (!userData || !userData.id)) {
                        this.language = res.language;
                        localStorage.setItem('language', res.language);
                        this.lan.setLanguage(res.language);
                    }

                    if (this.favIcon && res.data.favicon) {
                        this.favIcon.href =
                            res.data.imagePath + res.data.favicon;
                    }
                    setTimeout(() => {
                        this.fuseSpashScreen.hide();
                        document.body.classList.remove(
                            'fuse-splash-screen-hidden'
                        );
                        document.body.classList.add('removeLoader');
                    }, 500);
                } else {
                }
            },
            error: (err) => {
                console.log('err', err);
                if (err == 'Server Error') {
                    window.location.href = 'https://partnereach.com/';
                    return;
                }
                if (err == 'deactivated') {
                    window.location.href = 'https://partnereach.com/';
                    return;
                }
            },
        });
    }

    getProfileData() {
        this.api.getData('profile').subscribe({
            next: (res: any) => {
                if (res.success) {
                    res.data.token = localStorage.getItem('token');
                    localStorage.setItem(
                        'currentUser',
                        JSON.stringify(res.data)
                    );
                    this.authFackservice.currentUserSetValue(res.data);
                    if (this.language != res.data.language) {
                        localStorage.setItem('language', res.data.language);
                        this.lan.setLanguage(res.data.language);
                    }
                } else {
                }
            },
            error: (err) => {
                console.log('err', err);
            },
            complete() {},
        });
    }

    getCurrentPlan() {
        this.api.getData('current-plan').subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.api.activatedPlan = res.data;
                    this.api.currentPlanLoaded.next(true);
                } else {
                }
            },
            error: (err) => {
                console.log('err', err);
            },
        });
    }

    getMappingField() {
        this.api.getData('get-mapping-field').subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.mapping.mappingField = res.data;
                    this.mapping.isLoadMappingField.next(true);
                } else {
                }
            },
            error: (err) => {
                console.log('err', err);
            },
            complete() {},
        });
    }
}
